module.exports = __webpack_public_path__ + "img/DK21769916.74d01355.png";